// Module
var code = "<img class=\"img\" ng-src=\"{{vm.src}}\" ng-hide=\"vm.isFailure\"/> <span class=\"alt\" ng-show=\"vm.isFailure\">{{vm.alt}}</span> ";
// Exports
module.exports = code;